import Beschreibung from "./Beschreibung/Beschreibung.vue";
import Konzept from "./Konzept/Konzept.vue";
import Foerderangebote from "./Foerderangebote/Foerderangebote.vue";

export default {
  Beschreibung,
  Konzept,
  Foerderangebote,
};
